// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"245a2659","599":"c6846e2f"}[chunkId] + ".chunk.css";
};